import { render } from "./index.vue?vue&type=template&id=7a9f5e51&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=7a9f5e51&scoped=true&lang=css"

import exportComponent from "/home/wido/Documents/Project/SS-GreedGreed/ss-web-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a9f5e51"]])

export default __exports__